// src/Utils/number.js

// ✅ Keep ONLY digits (useful for integer fields like experience)
export const keepDigitsString = (val) => {
    return String(val ?? "").replace(/[^0-9]/g, "");
  };
  
  // ✅ Keep digits + ONE dot, allow "", ".", "1.", ".5", "10.25"
  export const keepDecimalString = (val) => {
    const cleaned = String(val ?? "").replace(/[^0-9.]/g, "");
    const parts = cleaned.split(".");
    if (parts.length <= 2) return cleaned;
    return `${parts[0]}.${parts.slice(1).join("")}`; // keep only first dot
  };
  
  // ✅ Convert (at submit time) to number or null
  export const toFloatOrNull = (val) => {
    const s = keepDecimalString(val);
    if (s === "" || s === ".") return null;
    const n = parseFloat(s);
    return Number.isFinite(n) ? n : null;
  };
  
  // ✅ Convert (at submit time) to integer or null
  export const toIntOrNull = (val) => {
    const s = keepDigitsString(val);
    if (s === "") return null;
    const n = parseInt(s, 10);
    return Number.isFinite(n) ? n : null;
  };
  export const keepDecimal2String = (value) => {
    if (value === null || value === undefined) return "";
  
    let v = String(value);
  
    // allow only digits + dot
    v = v.replace(/[^0-9.]/g, "");
  
    // only one dot
    const parts = v.split(".");
    if (parts.length > 2) {
      v = parts[0] + "." + parts.slice(1).join("");
    }
  
    const [intPart, decPart] = v.split(".");
  
    // limit decimal to 2 digits
    if (decPart !== undefined) {
      return `${intPart}.${decPart.slice(0, 2)}`;
    }
  
    return intPart;
  };
  